import { useEditorDoc } from 'common/Prose/EditorProvider/hooks/useEditorDoc'
import { schema } from 'prose-core'
import { Node } from 'prosemirror-model'
import { findChildrenByType } from 'prosemirror-utils'
import { SUPPORTED_HEADING_LEVELS } from './constants'

export const findDocHeadings = (doc: Node) =>
  findChildrenByType(doc, schema.nodes.heading, true)
    .filter(({ node }) => SUPPORTED_HEADING_LEVELS.includes(node.attrs.level))
    .map(({ node }) => node)

export const useDocHeadings = () => {
  const doc = useEditorDoc()

  return findDocHeadings(doc)
}
